export enum ROLES {
  Admin = 'Administrator',
  SeniorClinician = 'SeniorClinician',
  MasterClinician = 'MasterClinician',
  Clinician = 'Clinician',
  SuperAdministrator = 'SuperAdministrator',
  ClientPrimaryAccount = 'ClientPrimaryAccount',
}
